import React from 'react';
import { ShieldAlert, Key, Smartphone, Lock } from 'lucide-react';

const Security = ({ userData }: { userData?: any }) => {
  if (!userData) return null;

  return (
    <div className="max-w-4xl mx-auto space-y-8 font-[Urbanist]">
      <div>
        <h1 className="text-3xl md:text-4xl font-black text-[#0f172a]">Security Settings</h1>
        <p className="text-[#64748b] font-medium mt-1 text-sm md:text-base">Keep your account safe and manage connected devices.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        
        {/* Credentials Card (Read Only) */}
        <div className="bg-white border border-[#f1f5f9] rounded-[30px] p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col justify-center items-center text-center">
          <div className="w-16 h-16 bg-[#eff6ff] rounded-full flex items-center justify-center mb-4 border border-[#e0f2fe]">
            <Lock className="text-[#3b82f6]" size={28} strokeWidth={2.5} />
          </div>
          <h3 className="text-xl font-black text-[#0f172a] mb-2">Account Credentials</h3>
          <p className="text-sm font-bold text-[#64748b] mb-6 leading-relaxed">
            For security reasons, password modification is restricted on the customer portal. 
            All credential updates are managed centrally.
          </p>
          <div className="bg-[#f8fafc] border border-[#f1f5f9] rounded-[20px] p-5 w-full">
            <p className="text-[10px] text-[#94a3b8] uppercase font-bold tracking-widest mb-1.5">Your Login ID</p>
            <p className="text-lg font-black text-[#0f172a] tracking-wide">{userData.login_id}</p>
          </div>
          <p className="text-[11px] font-bold text-[#94a3b8] mt-4">Please contact your account manager or admin to request a password reset.</p>
        </div>

        <div className="space-y-6">
          {/* 2FA Card */}
          <div className="bg-white border border-[#f1f5f9] rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex items-start gap-4">
            <div className="p-3 bg-purple-50 rounded-[16px] shrink-0"><ShieldAlert className="text-purple-600" size={24} strokeWidth={2.5} /></div>
            <div>
              <h3 className="text-lg font-black text-[#0f172a] mb-1">Two-Factor Auth (2FA)</h3>
              <p className="text-sm font-bold text-[#64748b] mb-4">Add an extra layer of security to your account using an authenticator app.</p>
              <button className="bg-[#0f172a] text-white px-5 py-2.5 rounded-[12px] text-sm font-black hover:bg-[#1e293b] transition-colors">Enable 2FA</button>
            </div>
          </div>

          {/* Active Sessions */}
          <div className="bg-white border border-[#f1f5f9] rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-[#f8fafc] rounded-lg border border-[#f1f5f9]"><Smartphone className="text-[#64748b]" size={20} strokeWidth={2.5}/></div>
              <h3 className="text-[#0f172a] font-black">Active Sessions</h3>
            </div>
            <div className="flex items-center justify-between p-4 bg-[#f8fafc] rounded-[16px] border border-[#f1f5f9]">
              <div>
                <p className="text-[#0f172a] text-sm font-black mb-0.5">Windows • Chrome</p>
                <p className="text-[11px] font-bold text-emerald-600 uppercase tracking-widest">Current Session (India)</p>
              </div>
              <button className="text-[11px] font-black uppercase tracking-wider text-red-500 hover:text-red-700 transition-colors">Log out</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Security;